<script setup>
import {ref} from "vue";
import EcosystemsAccessSettings from "@/components/trackers/EcosystemsAccessSettings.vue";
import trackersService from "@/services/trackers.service";

const {trackerId} = defineProps(['trackerId']);
const emit = defineEmits(['saved']);
const accessSettingsModal = ref(null);

async function getAccessSettings() {
    const {data} = await trackersService.getAccessSettings(trackerId);
    let [accessType, ecosystems] = data;

    accessSettingsModal.value.open(accessType, ecosystems);
}

async function saveAccessSettings({accessType, ecosystems}) {
    await trackersService.saveAccessSettings(trackerId, {accessType, ecosystems});
    emit('saved');
}

function open() {
    getAccessSettings();
}

defineExpose({
    open
});
</script>

<template>
    <EcosystemsAccessSettings
        ref="accessSettingsModal"
        @saved="saveAccessSettings"
    />
</template>

<style scoped>

</style>
